module.exports = __webpack_public_path__ + "assets/img/time-bg-01.cbb7d135.png";